export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-2.cd628f19.jpg";